import React, { useState } from "react";
import Odds from "./Odds";
import OddsPCHeaderItem from "./Odds.pc.HeaderItem";
import { useClickOutside } from "../../hooks";

function OddsPC() {
  const [showDropdown, setShowDropdown] = useState(false);

  const currentRef = useClickOutside(
    () => {
      setShowDropdown(false);
    },
    { disabled: !showDropdown }
  );

  const handleMenuItemClick = () => {
    setShowDropdown(!showDropdown);
  };

  return (
    <OddsPCHeaderItem
      reference={currentRef}
      handleClick={handleMenuItemClick}
      show={showDropdown}
    >
      <div className="odds-content">
        <Odds handleClick={handleMenuItemClick} />
      </div>
    </OddsPCHeaderItem>
  );
}

export default React.memo(OddsPC);
